import { render, staticRenderFns } from "./liveRecorder.vue?vue&type=template&id=4c872644&scoped=true&"
import script from "./liveRecorder.vue?vue&type=script&lang=js&"
export * from "./liveRecorder.vue?vue&type=script&lang=js&"
import style0 from "./liveRecorder.vue?vue&type=style&index=0&id=4c872644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c872644",
  null
  
)

export default component.exports